{
  "Unknown response data: {res}": "返答内容が不明です。 {res}",
  "Failed to fetch contract for publisher id: {pubId}": "パブリッシャー ID: {pubId} の契約を読み込むのに失敗しました。",
  "Something went wrong": "誤作動",
  "We aren't able to process your request. Please try again": "処理を行うことができません。もう一度お試しください。",
  "Back to google": "googleに戻る",
  "Success": "成功",
  "Please click button below to return to Google Ad Manager, acknowledge the partnership agreement was signed, and agree to the Open Bidding terms to work with our inventory.": "下のボタンをクリックしてGoogleAdManager / AdMobに戻ってください。パートナーシップ契約が締結されたことを確認してから、広告枠を使用するための公開入札条件に同意してください。",
  "Back to Google": "Googleに戻る",
  "Here": "こちら",
  "you can find more information on what to expect next.": "詳細の確認",
  "Thank you for choosing OpenX as a Google Open Bidding partner!": "OpenXをGoogle Open Biddingのパートナーとしてお選びいただき、誠にありがとうございます。",
  "Unknown google data": "不明なgoogleデータ",
  "Your request is being validated. It might take up to a few minutes...": "リクエストを検証しています。数分間かかる場合があります。",
  "Something went wrong. Try again or refresh the page.": "エラーが発生しました。もう一度試すか、ページを更新してください。",
  "Your Details": "詳細",
  "Legal Company Name": "会社名",
  "Type your company name": "会社名を入力してください",
  "Company Website": "会社ウェブサイト",
  "Company Website is required": "会社のホームページが必須項目です",
  "Type your company website address": "会社のウェブサイトのURLを入力する",
  "Email": "メールアドレス",
  "Type your email for our contact records (you can enter multiple addresses by enter)": "契約記録のためのメールアドレスを入力してください（Enterキーを押すと複数のアドレスを入力できます）",
  "Inventory details": "在庫の詳細",
  "Google Account Type": "Google アカウントタイプ",
  "Google Network Code": "Google ネットワークコード",
  "Google Publisher ID": "Google パブリッシャー ID",
  "domain": "ドメイン",
  "Upload domains": "ドメインのアップロード",
  "bundle": "バンドル",
  "Upload bundles": "バンドルのアップロード",
  "I agree that I have reviewed the OB Service Terms and that I am authorized to sign these terms on behalf of my company.": "私はOBサービス規約を確認しており、また会社を代表してこれらの規約に署名する権限を持ってます",
  "Submit": "送信",
  "OpenX Terms & Conditions": "OpenXの利用規約",
  "OpenX Terms&Conditions": "OpenXの利用規約",
  "Download as PDF": "PDFをダウンロードする",
  "CSV file format required": "CSVファイル形式が必要です",
  "{resourceName}s-template": "{resourceName}テンプレート",
  "Hide": "隠す",
  "Show": "表示",
  "details": "詳細",
  "Please download the following template to upload your {resourceName}s. The resulting files should include no more than 1 column and each new {resourceName} should be on a new row.": "以下のテンプレートをダウンロードし、{resourceName}をアップロードしてください。ドメインが1つ以上ある場合、{resourceName}ごとに改行してください。",
  "Download template": "テンプレートをダウンロードする",
  "Company Name is required": "会社名は必須項目です",
  "Company Website must be a valid URL": "会社のウェブサイトは有効なURLである必要があります。",
  "Some of the above emails is invalid": "上記のメールアドレスの一部は無効です",
  "Email is required": "メールアドレスは必須項目です",
  "Field must be checked": "フィールドにチェックを入れる必要があります",
  "The format of the file is not valid. Only CSV files are supported.": "ファイルの形式が無効です。CSVファイルのみ対応しています。",
  "Bundles file is required": "バンドル(App ID)のファイルが必要です。",
  "At least one of domains and bundles files has to be provided": "ドメインまたはバンドルファイルのどれか1つアップロードする必要があります",
  "Validation error": "検証エラー",
  "OpenX Ad Exchange": "OpenX アドエクスチェンジ",
  "OpenX is a pioneering leader in advertising technology, helping create a world where the open web thrives.": "OpenXは広告テクノロジー業界のリーディングカンパニーであり、オープンウェブが繁栄する世界の創造に貢献しています。",
  "Powerful Monetization": "パワフルなマネタイズ",
  "The OpenX Ad Exchange comes equipped with built in demand from 100% of the top 100 AdAge Advertisers, accessing all screens and ad formats.": "OpenX アドエクスチェンジには、AdAgeが定める上位100社の全ての広告主からあらゆるスクリーンタイプと広告フォーマットに対しての入札があります。",
  "Details": "詳細を",
  "Confirmation": "確認",
  "Google OB Online Onboarding": "Google OBオンラインオンボーディング",
  "OpenX Publisher Benefits": "OpenX パブリッシャーのメリット",
  "DROP FILE HERE": "ファイルをドロップする、",
  "or": "また",
  "Browse": "はファイルを選択してください",
  "REMOVE": "削除",
  "English / United States": "米語",
  "Japanese": "日本語"
}